// extracted by mini-css-extract-plugin
export default {"title":"Deighth_title__rmD4L","desc":"Deighth_desc__prj8O","text":"Deighth_text__j4QFO","Deighth":"Deighth_Deighth__6ATM3"};